/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Online_Coaching_TermsInputs */

const en_service_type_online_coaching_terms = /** @type {(inputs: Service_Type_Online_Coaching_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`online trainer, remote coaching, online personal training`)
};

const pl_service_type_online_coaching_terms = /** @type {(inputs: Service_Type_Online_Coaching_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trener online, coaching online, prowadzenie treningowe, opieka online, trening zdalny`)
};

/**
* | output |
* | --- |
* | "online trainer, remote coaching, online personal training" |
*
* @param {Service_Type_Online_Coaching_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_online_coaching_terms = /** @type {((inputs?: Service_Type_Online_Coaching_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Online_Coaching_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_online_coaching_terms(inputs)
	return en_service_type_online_coaching_terms(inputs)
});